import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function List({ ...props }: IconProps): JSX.Element {
  const Icon = createWebIcon({
    ...props,
    name: `List`,
    path: (
      <>
        <circle cx="6.39952" cy="5.4514" r="1.40049" fill="currentColor" />
        <path
          d="M12.0411 4.06937V4.0509H17.5593C18.355 4.0509 19.0012 4.69706 19.0012 5.48907C19.0012 6.30323 18.355 6.94939 17.5593 6.94939H12.0411C11.2454 6.94939 10.6011 6.30323 10.6011 5.50938C10.6011 4.71553 11.2454 4.06937 12.0411 4.06937"
          fill="currentColor"
        />
        <circle cx="6.39952" cy="11.9513" r="1.40049" fill="currentColor" />
        <path
          d="M12.0411 10.5692V10.5508H17.5593C18.355 10.5508 19.0012 11.1969 19.0012 11.9889C19.0012 12.8031 18.355 13.4493 17.5593 13.4493H12.0411C11.2454 13.4493 10.6011 12.8031 10.6011 12.0093C10.6011 11.2154 11.2454 10.5692 12.0411 10.5692"
          fill="currentColor"
        />
        <circle cx="6.39952" cy="18.4512" r="1.40049" fill="currentColor" />
        <path
          d="M12.0411 17.0691V17.0507H17.5593C18.355 17.0507 19.0012 17.6968 19.0012 18.4888C19.0012 19.303 18.355 19.9491 17.5593 19.9491H12.0411C11.2454 19.9491 10.6011 19.303 10.6011 18.5091C10.6011 17.7153 11.2454 17.0691 12.0411 17.0691"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon w="element.md" h="element.md" {...validateKeys(props)} />;
}
